import React from 'react';

export const SideBarMenuIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 64 64"
    >
      <path fill="currentColor" d="m50 8h-36c-3.309 0-6 2.691-6 6v36c0 3.309 2.691 6 6 6h36c3.309 0 6-2.691 6-6v-36c0-3.309-2.691-6-6-6zm-38 42v-36c0-1.103.897-2 2-2h8v40h-8c-1.103 0-2-.897-2-2zm40 0c0 1.103-.897 2-2 2h-24v-40h24c1.103 0 2 .897 2 2z" />
    </svg>
  );
};
